<div class="tw-fixed tw-left-4 tw-z-50 tw-space-y-2" style="bottom: 70px;">
  <div
    *ngFor="let operation of operations$ | async"
    class="tw-bg-white tw-rounded-lg tw-shadow-lg tw-border tw-border-gray-200 tw-transition-all tw-duration-300"
    [class.tw-w-12]="operation.hidden"
    [class.tw-h-12]="operation.hidden"
    [class.tw-w-96]="!operation.hidden"
  >
    <!-- Collapsed state - Perfect Square with Centered Icon -->
    <div
      *ngIf="operation.hidden"
      class="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center tw-cursor-pointer hover:tw-bg-gray-50 tw-rounded-lg tw-transition-colors"
      (click)="expandOperation(operation.batchId)"
    >
      <mat-icon 
        *ngIf="operation.status === 'processing'"
        class="tw-text-blue-600 spinning-icon"
        [style.fontSize.px]="24"
        [style.width.px]="24"
        [style.height.px]="24"
      >
        autorenew
      </mat-icon>
      <mat-icon 
        *ngIf="operation.status === 'completed'"
        class="tw-text-green-600"
        [style.fontSize.px]="24"
        [style.width.px]="24"
        [style.height.px]="24"
      >
        check_circle
      </mat-icon>
      <mat-icon 
        *ngIf="operation.status === 'failed'"
        class="tw-text-red-600"
        [style.fontSize.px]="24"
        [style.width.px]="24"
        [style.height.px]="24"
      >
        error
      </mat-icon>
    </div>

    <!-- Expanded state -->
    <div *ngIf="!operation.hidden" class="tw-p-4">
      <div class="tw-flex tw-items-start tw-justify-between tw-mb-3">
        <div class="tw-flex-1">
          <div class="tw-font-semibold tw-text-gray-900 tw-mb-1">
            {{ getOperationLabel(operation.operation) }}
          </div>
        </div>
        <button
          (click)="operation.status === 'completed' || operation.status === 'failed' ? dismissOperation(operation.batchId) : hideOperation(operation.batchId)"
          class="tw-text-gray-400 hover:tw-text-gray-600 tw-transition-colors tw-ml-2"
        >
          <mat-icon class="tw-text-lg">{{ operation.status === 'completed' || operation.status === 'failed' ? 'close' : 'remove' }}</mat-icon>
        </button>
      </div>

      <!-- Progress bar with shimmer effect -->
      <div class="tw-w-full tw-bg-gray-200 tw-rounded-full tw-h-2 tw-mb-2 tw-overflow-hidden tw-relative">
        <div
          class="progress-bar tw-h-2 tw-rounded-full tw-transition-all tw-duration-500 tw-ease-out tw-relative"
          [class.tw-bg-blue-500]="operation.status === 'processing'"
          [class.tw-bg-green-500]="operation.status === 'completed'"
          [class.tw-bg-red-500]="operation.status === 'failed'"
          [class.shimmer]="operation.status === 'processing'"
          [style.width.%]="getProgressPercentage(operation)"
        ></div>
      </div>

      <!-- Keep view open message -->
      <div *ngIf="operation.status === 'processing'" class="tw-text-xs tw-text-gray-500 tw-italic tw-mb-1">Keep this view open</div>

      <!-- Status messages -->
      <div *ngIf="operation.status === 'completed'" class="tw-text-sm tw-text-green-600 tw-flex tw-items-center tw-gap-1">
        <mat-icon class="tw-text-base">check_circle</mat-icon>
        Completed successfully
      </div>
      <div *ngIf="operation.status === 'failed'" class="tw-text-sm tw-text-red-600 tw-flex tw-items-center tw-gap-1">
        <mat-icon class="tw-text-base">error</mat-icon>
        Operation failed
      </div>
    </div>
  </div>
</div>

